import { copilotBaseUrl } from './baseUrl'

/** True when the URL targets the copilot API. Its one caller is the global 401 handler — see
 *  `shared/api/unauthorizedInterceptor` for why a copilot 401 must not end the Tardek session. */
export default function isCopilotUrl(url: string | undefined): boolean {
  return !!url && url.startsWith(`${copilotBaseUrl()}/`)
}
